const clients = new WeakMap();
const cacheable = /\/(?:form\/lookup|permission-management\/(?:bootstrap|roles|effective-permissions))$/;

export function sharedApiGet(axios, url, config) {
  let state = clients.get(axios);
  if (!state) {
    state = { entries: new Map(), scope: '' };
    clients.set(axios, state);
    if (axios.interceptors?.response) {
      const invalidate = response => {
        const method = String(response?.config?.method || response?.response?.config?.method || 'get').toLowerCase();
        if (method !== 'get' && method !== 'head') state.entries.clear();
        return response;
      };
      axios.interceptors.response.use(invalidate, error => { invalidate(error); return Promise.reject(error); });
    }
  }
  const scope = String(axios.defaults?.headers?.common?.Authorization || '');
  if (scope !== state.scope) { state.entries.clear(); state.scope = scope; }
  if (!cacheable.test(url.split('?')[0]) || config?.params || config?.headers || config?.signal || config?.cancelToken) return axios.get(url, config);
  let entry = state.entries.get(url);
  if (!entry || entry.expires <= Date.now()) {
    entry = { expires: Infinity };
    entry.promise = axios.get(url, config).then(response => {
      if (!response || response.status >= 400 || response.data == null) throw new Error('Auswahldaten konnten nicht geladen werden.');
      entry.expires = Date.now() + 60000;
      return response;
    }).catch(error => { if (state.entries.get(url) === entry) state.entries.delete(url); throw error; });
    state.entries.set(url, entry);
  }
  // Components may filter or mutate their response; never share mutable objects.
  return entry.promise.then(response => {
    if (String(axios.defaults?.headers?.common?.Authorization || '') !== scope)
      throw new Error('Die Sitzung hat sich während des Ladens geändert.');
    return { ...response, data: JSON.parse(JSON.stringify(response.data)) };
  });
}
